import { render, staticRenderFns } from "./buttonGroup.vue?vue&type=template&id=096f2e70&scoped=true&"
import script from "./buttonGroup.vue?vue&type=script&lang=js&"
export * from "./buttonGroup.vue?vue&type=script&lang=js&"
import style0 from "./buttonGroup.vue?vue&type=style&index=0&id=096f2e70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096f2e70",
  null
  
)

export default component.exports